var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGoogleMeet = function SvgGoogleMeet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.1 4.7-2.4 2.1V4.2c0-.6-.5-1.2-1.1-1.2H5.7L2 7v8.8c0 .7.5 1.2 1.1 1.2h10.5c.6 0 1.1-.5 1.1-1.2v-2.5l2.4 2.1c.4.3.9 0 .9-.5V5.1c0-.5-.5-.7-.9-.4zm-6 8.3H5.7V7H11v6z"
  })));
};
export default SvgGoogleMeet;